import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import Customform from "../../../ui/custom-form";
import CustomInput from "../../../ui/custom-input";
import CustomButton from "../../../ui/custom-button";
import { AddCourseApi, getCourseData, UpdateCourseApi } from "../../../api/api";
import { PulseLoader } from "react-spinners";

function AddCourse() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { data } = useSelector((state) => state?.PopupReducer?.modal || {});
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );

  const [inputData, setInputData] = useState({
    course_name: "",
    subject_blocks: [
      {
        semester: "",
        semester_description: "",
        subjects: [],
        tempSubject: "",
      },
    ],
  });

  const fetchDetail = async () => {
    try {
      const detail = await getCourseData(data, user_id, organization_id);
      if (detail.data.status === true) {
        const res = detail.data.data;
        const semesterMap = {};

        res.course_data.forEach((entry) => {
          const { semester_name, subject_name } = entry;
          if (!semesterMap[semester_name]) {
            semesterMap[semester_name] = [];
          }
          semesterMap[semester_name].push(subject_name);
        });

        const subject_blocks = Object.entries(semesterMap).map(
          ([semester, subjects]) => ({
            semester,
            semester_description: "",
            subjects,
            tempSubject: "",
          })
        );

        setInputData({
          course_name: res.course_name || "",
          subject_blocks,
        });
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    if (data) {
      fetchDetail();
    }
  }, []);

  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
      })
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubjectBlockChange = (field, value, index = 0) => {
    setInputData((prev) => {
      const updated = [...prev.subject_blocks];
      updated[index] = { ...updated[index], [field]: value };
      return { ...prev, subject_blocks: updated };
    });
  };

  const handleAddSemester = () => {
    setInputData((prev) => ({
      ...prev,
      subject_blocks: [
        ...prev.subject_blocks,
        {
          semester: "",
          semester_description: "",
          subjects: [],
          tempSubject: "",
        },
      ],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (data) {
        const payload = {
          course_name: inputData.course_name,
          course_id: data ? data : "",
          course_data: inputData.subject_blocks.map((block) => ({
            semester_name: block.semester,
            semester_description: block.semester_description || "",
            subjects: block.subjects.map((subject) => ({
              subject_name: subject,
              subject_description: "",
            })),
          })),
          user_id,
          organization_id,
        };
        const editDetail = await UpdateCourseApi(payload, data);
        if (editDetail) handleClose();
      } else {
        const payload = {
          course_name: inputData.course_name,
          course_data: inputData.subject_blocks.map((block) => ({
            semester_name: block.semester,
            semester_description: block.semester_description || "",
            subjects: block.subjects.map((subject) => ({
              subject_name: subject,
              subject_description: "",
            })),
          })),
          user_id,
          organization_id,
        };
        const dataSubmit = await AddCourseApi(payload);
        if (dataSubmit) handleClose();
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h5 className="m-0">{data ? "Edit" : "Add"} Course</h5>
        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline color="#fff" size={20} />
        </button>
      </div>

      <div className="p-4 formBox formCstHeight">
        <Customform onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Course Name</label>
            <CustomInput
              name="course_name"
              placeholder="Enter Course Name"
              value={inputData.course_name}
              onChange={handleChange}
            />
          </div>

          <hr className="hr my-4" />

          <h6 className="fw-semibold mb-3">Semesters</h6>

          {inputData.subject_blocks.map((block, index) => (
            <div key={index} className="mb-4 border rounded p-3">
              <div className="mb-3">
                <label className="form-label">Semester</label>
                <select
                  className="form-select"
                  value={block.semester}
                  onChange={(e) =>
                    handleSubjectBlockChange("semester", e.target.value, index)
                  }
                >
                  <option value="">Select</option>
                  <option value="Semester 1">Semester 1</option>
                  <option value="Semester 2">Semester 2</option>
                  <option value="Semester 3">Semester 3</option>
                  <option value="Semester 4">Semester 4</option>
                  <option value="Semester 5">Semester 5</option>
                  <option value="Semester 6">Semester 6</option>
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Subject Name</label>
                <div className="d-flex flex-wrap gap-2">
                  {block.subjects.map((subject, sIdx) => (
                    <span
                      key={sIdx}
                      className="badge bg-primary d-flex align-items-center gap-2"
                    >
                      {subject}
                      <button
                        type="button"
                        className="btn btn-sm btn-close"
                        onClick={() => {
                          const updatedSubjects = block.subjects.filter(
                            (_, i) => i !== sIdx
                          );
                          handleSubjectBlockChange(
                            "subjects",
                            updatedSubjects,
                            index
                          );
                        }}
                      />
                    </span>
                  ))}
                  <CustomInput
                    type="text"
                    placeholder="Add subject and press Enter"
                    value={block.tempSubject}
                    onChange={(e) =>
                      handleSubjectBlockChange(
                        "tempSubject",
                        e.target.value,
                        index
                      )
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && e.target.value.trim()) {
                        e.preventDefault();
                        const newSubjects = [
                          ...block.subjects,
                          e.target.value.trim(),
                        ];
                        handleSubjectBlockChange(
                          "subjects",
                          newSubjects,
                          index
                        );
                        handleSubjectBlockChange("tempSubject", "", index);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          ))}

          <button
            type="button"
            className="btn btn-outline-primary mb-4"
            onClick={handleAddSemester}
          >
            + Add Another Semester
          </button>

          <div className="buttonGroup d-flex justify-content-between position-absolute start-0 bottom-0 w-100 p-4 border-top mt-5 bg-white">
            <button
              className="cancelBtn w-100"
              type="button"
              onClick={handleClose}
            >
              Cancel
            </button>
            {loading ? (
              <CustomButton type="submit" className="btnSubmit px-4 py-2">
                <PulseLoader color="#fff" size={8} />
              </CustomButton>
            ) : (
              <button className="btnSubmit px-4 py-2" type="submit">
                {data ? "Update" : "Submit"}
              </button>
            )}
          </div>
        </Customform>
      </div>
    </div>
  );
}

export default AddCourse;
